export default __webpack_public_path__ + "static/media/release-management.bfd23e81.svg";